import { Table } from "antd";
import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";

import { renderChart } from "../until/renderDataChart";
const ChartWatingTime = ({ dataChart, nam }) => {
  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");
    renderChart(dataChart, nam, root, 0);
    return () => {
      root.dispose();
    };
  }, [dataChart, nam]);

  return (
    <div>
      <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 18 }}>
        AVERAGE WATTING TIME IN EACH SECTION JAN - DEC {nam}
      </div>
      <div className="container">
        <div id="chartdiv" style={{ height: "300px" }}></div>
      </div>
    </div>
  );
};

export default ChartWatingTime;
